import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c4-four-two',
  templateUrl: './c4-four-two.component.html',
  styleUrls: ['./c4-four-two.component.scss']
})
export class C4FourTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
